import logo from './componeons/assets/logo.svg';
import LogoSm from './componeons/assets/logo-sm.svg';
import X from './componeons/assets/X.svg';
import CopyIcon from './componeons/assets/Copy_icon.svg';
import CountdownTimer from './Timer';
import Timer from "./componeons/assets/timer.svg"
import Prime from "./componeons/assets/bnb-bnb-logo.svg"
import Phantom from "./componeons/assets/metamask-icon.svg";
import Close from "./componeons/assets/close.svg";
import Arrow from "./componeons/assets/arrow.svg";

import './App.css';

import { useState, useRef, useEffect } from 'react';




function App() {
   const [count, setCount] = useState(1000);
  const [displayValue, setDisplayValue] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showConnectPopup, setShowConnectPopup] = useState(false);
  const [showLoadingPopup, setShowLoadingPopup] = useState(false);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
  const [showRefresh, setShowRefresh] = useState(false);
  const [showLogoutButton, setShowLogoutButton] = useState(false);
  const [inputValue, setInputValue] = useState('1000');
  const [inputWidth, setInputWidth] = useState(50);
  const [progress, setProgress] = useState(0);
  const hiddenSpanRef = useRef(null);
  const inputRef = useRef(null);
const logoutButtonRef = useRef(null);

  // Эффект для блокировки прокрутки body при открытии модального окна
  useEffect(() => {
    const hasPopup = showConnectPopup || showLoadingPopup || showLogoutPopup || showRefresh;
    
    if (hasPopup) {
      document.body.classList.add('popup-open');
    } else {
      document.body.classList.remove('popup-open');
    }
    
    // Очистка при размонтировании
    return () => {
      document.body.classList.remove('popup-open');
    };
  }, [showConnectPopup, showLoadingPopup, showLogoutPopup,  showRefresh]);

  // Функция для обновления ширины input
  const updateInputWidth = () => {
    if (hiddenSpanRef.current && inputRef.current) {
      const width = hiddenSpanRef.current.offsetWidth;
      setInputWidth(width + 10);
    }
  };

useEffect(() => {
  const handleClickOutside = (event) => {
    if (logoutButtonRef.current && !logoutButtonRef.current.contains(event.target)) {
      setShowLogoutButton(false);
    }
  };

  if (showLogoutButton) {
    document.addEventListener('mousedown', handleClickOutside);
  }

  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [showLogoutButton]);

  useEffect(() => {
    updateInputWidth();
  }, [inputValue]);

  // Эффект для анимации прогресса
  useEffect(() => {
    let interval;
    if (showLoadingPopup) {
      setProgress(0);
      interval = setInterval(() => {
        setProgress(prev => {
          if (prev >= 100) {
            clearInterval(interval);
            // Завершаем процесс через 5 секунд
            setTimeout(() => {
              setIsLoggedIn(true);
              setShowLoadingPopup(false);
            }, 100);
            return 100;
          }
          return prev + 1;
        });
      }, 20); // 100% за 5 секунд (50ms * 100 = 5000ms)
    }
    return () => clearInterval(interval);
  }, [showLoadingPopup]);

  useEffect(() => {
    let interval;
    if (showLogoutPopup) {
      setProgress(0);
      interval = setInterval(() => {
        setProgress(prev => {
          if (prev >= 100) {
            clearInterval(interval);
            // Завершаем процесс через 5 секунд
            setTimeout(() => {
              setShowLogoutPopup(false);
              setShowRefresh(true);
            }, 100);
            return 100;
          }
          return prev + 1;
        });
      }, 20);
    }
    const restart =() =>{
      return() => clearInterval(interval);

    }
    return () => clearInterval(interval);
  }, [showLogoutPopup]);

  // Функции для счетчика
  const increment = () => {
    const newCount = count + 1;
    setCount(newCount);
    setInputValue(newCount.toString());
  };

  const decrement = () => {
    const newCount = count - 1;
    setCount(newCount);
    setInputValue(newCount.toString());
  };

  const setMax = () => {
    setCount(176880);
    setInputValue('176880');
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    
    if (!isNaN(value) && value !== '') {
      setCount(parseInt(value));
    }
  };

  const handleInputBlur = () => {
    if (inputValue === '') {
      const value = count.toString();
      setInputValue(value);
    }
  };

  // Функция для переноса значения
  const transferValue = () => {
    if (!isLoggedIn) {
      setShowConnectPopup(true);
    } else {
      setDisplayValue(displayValue+count);
      setShowLogoutPopup(true)
    }
  };

  // Функции для авторизации
  const handleConnect = () => {
    setShowConnectPopup(false);
    setShowLoadingPopup(true);
  };
  const handleRefresh = () => {
    // restart(true)
    setShowRefresh(false);
    setShowLogoutPopup(true);
  };
  const handleLoginClick = () => {
    if (!isLoggedIn) {
      setShowConnectPopup(true);
    } else {
      // Показываем/скрываем кнопку выхода
      setShowLogoutButton(!showLogoutButton);
    }
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setShowLogoutPopup(false);
    setShowLogoutButton(false);
    setDisplayValue(0);
    setShowRefresh(false)
  };

  const textClassName = displayValue !== 0 ? 'buy_num text' : 'buy_num text-light';
  return (
    <div className="App">
      <header className="App-header">
          <div>
            <img src={logo} alt="Pass.fun" />
          </div>
          <div className="logout-container" ref={logoutButtonRef}>
<button onClick={handleLoginClick} className='btn header_btn' >
        {isLoggedIn ? 'Demo User' : 'Connect Wallet'}
      </button>
  
  {/* Кнопка выхода, появляющаяся при нажатии на Log Out */}
  {showLogoutButton && isLoggedIn && (
    <button 
      className="logout-confirm-btn btn "
      onClick={handleLogout}
    >
      Log Out
    </button>
  )}
</div>

          {/* <button className='btn header_btn'>Connect Wallet</button> */}
       </header>
       <section className='all_templete'>
       <nav className='head-info'>
          <div className='info row'>
            <div className='icon'>
              <img src={LogoSm} alt="Pass.fun logo" />
            </div>
            <div className='info-column column'>
              <div className='row long'>
              <div className='Pass-fun row'>
              <p className='text '>Pass.fun</p>
                <a src="">  <img src={X} alt="X" /></a>
                </div>
                   <div className='timer row'>
                  <img src={Timer} alt="" />
                  <CountdownTimer/>
                </div>
              </div>
              <div className="colekt_token ">
                <div className='token row'>
                  <p className='text-light pass'>PASS</p>
                   <a> <img className='text-light' src={CopyIcon} alt="Copy icon" /></a>
                </div>
             
              </div>
              <p className='First text'>First memecoin raffle launchpad <br></br><hr/> <br></br>Pass. Win. Fun.</p>
            </div>
          </div>
       </nav>
       <section className='main'>
        <div className='main_componeons'>
          <div className='main_componeons-left'>
            <div className='blok left_compon row'>
              <div className='column sold'>
                <p className='text-light p14px'>Full amount</p>
                <p className='text pris'>$134k</p>
             </div>
             {/*  */}
             <div className='line-item'></div>
              <div className='column sold '>
                <div>
                  <p className='text-light left p14px'>Tickets Sold / Total Tickets</p>
                </div>
                <div className='row adap'>
                  <div className="row">
                  <p className='secondary'>833.120</p>
                  <p className='slash'>/</p>
                  <p>1.000.000</p>
                  </div>
                  <div className='load-line'>
                    <div class="minimal-progress">
                      <div class="minimal-fill"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='blok left_compon column'>
              <h4 className='text p18px left general'>General info</h4>
              <div className='row general-m'>
                <p className='text-light p14px p-mr '>Claim date: </p>
                 <div className="iner"><CountdownTimer /></div>    
              </div>
              <div className="row general-m">
                <p className='text-light p14px'>1 ticket = </p>
                <p className='p-ml iner'>0,3 tokens</p>
              </div>
              <div className="row ">
                <p className='text-light p14px'>Token Price  </p>
                <p className='p-ml p-mr6 iner'>0,05 </p>
                <img className='mini' src={Prime} alt="" />
              </div>
            </div>
          </div>
          <div className='main_componeons-right'>
            <h3>Participate now</h3>
            <div className=' blok column'>
              <div className='interect'>
                <div className="row buy-wind bott-m">
                  <p className='text-light p12px'>Buy tickets</p>
                  <div className='row'>
                  <p className='text-light p12px'>1 ticket =</p>
                  <p className='text p12px marg '> 1.6 tokens</p>
                  </div>
                </div>
                  <div className="row buy-wind">
                        <div className="num row">
                          <img className='buy_logo' src={LogoSm} alt="" />
                          <p className={textClassName}>{displayValue}</p>
                        </div>
                        <div className="row interect_btn">
                          <button className='btn_max' onClick={setMax}>Max</button>
                          <button className='btn_plas plas' onClick={decrement}>-</button>
                                <input 
                                  ref={inputRef}
                                  type="text" 
                                  value={inputValue} 
                                  onChange={handleInputChange}
                                  onBlur={handleInputBlur}
                                  className="input"
                                  // style={{width: `${inputWidth}px`}}
                                />
                          <button className='btn_plas plas' onClick={increment}>+</button>
                        </div>
                </div>
              </div>
              <div className='buy-wind-info'>                
                <div className="row buy-wind general-m">
                  <p className='text-light p12px'>Token allocation</p>
                  <p className='text p12px'> 177.78 $PASS</p>
                </div>
                <div className="row buy-wind">
                  <p className='text-light p12px'>Total amount</p>
                  <p className='text p12px'> 3 USDT</p>
                </div>
                </div>
            </div>
                  <button className=' btn buy-wind-btn' onClick={transferValue} >
       {isLoggedIn ? 'BUY' : 'Connect Wallet'}
      </button>
            {/* <button className=' btn buy-wind-btn'>Connect Wallet</button> */}
          </div>
        </div>
       </section>
       <footer className='footer'>
        <div className='corp row'>   
        <p>Pass.fun</p>
        <p>2025</p>
        </div> 
        <p className='demo'>This is an early demo — we’re still building! Features may change as we keep improving the service. For now, you don’t need a wallet or registration to try it out.</p>
          <a src="">  <img src={X} alt="X" /></a>
       </footer>     
      </section>
      {/* Всплывающее окно подключения */}
 {showLogoutButton && isLoggedIn && (
          <button 
            className="logout-confirm-btn"
            onClick={() => setShowLogoutPopup(true)}
          >
            Выйти
          </button>
        )}


      {showConnectPopup && (
        <div className="popup">
          <div className="popup-content ">
            <div className="long-rev">
                        <button onClick={() => setShowConnectPopup(false)} className=' btn_plas close'> <img src={Close} alt="" />    </button>
                         </div>
            <h3>Connect wallet</h3>
            
            <button onClick={handleConnect} className='phantom'><img  className='mini2' src={Phantom} alt="" /><p> Phantom wallet</p></button>

          </div>
        </div>
      )}
      {showLoadingPopup && (
        <div className="popup">
          <div className="popup-content loading-popup">
            <div className='long'>
            <button onClick={() => setShowLoadingPopup(false)} className=' btn_plas close'> <img src={Arrow} alt="" />    </button> 
            <button onClick={() => setShowLoadingPopup(false)} className=' btn_plas close'> <img src={Close} alt="" />    </button> 
            </div>
            <div className="progress-circle-container wallet walletT">
              <div className="progress-circle">
                <div 
                  className="progress-circle-fill"
                  style={{
                    background: `conic-gradient(#FF59DB ${progress * 3.6}deg, #0F0F0F 0deg)`
                  }}
                ></div>
                <div className="progress-circle-inner">
                  <img src={Phantom} alt="" className="progress-logo" />
                </div>
              </div>
              <p className="progress-text wallet">Waiting for Phantom</p>
            </div>
            <p className='text-light wallet walletB'>Connecting wallet</p>
          </div>
        </div>
      )}

      {/* Всплывающее окно выхода */}
      {showLogoutPopup && (
        <div className="popup">
          
          <div className="popup-content exsit"> 
            <div className="long-rev">
            <button onClick={() => setShowLogoutPopup(false)} className=' btn_plas close'> <img src={Close} alt="" />    </button>
            </div>
            <h3>Raffle Results</h3>
                        <div className="progress-circle-container">
              <div className="progress-circle">
                <div 
                  className="progress-circle-fill"
                  style={{
                    background: `conic-gradient(#EDB708 ${progress * 3.6}deg, #0F0F0F 0deg)`
                  }}
                ></div>
                <div className="progress-circle-inner">

                </div>
              </div>
              <p className="progress-text"><p>Loading</p></p>
            </div>
                          <button onClick={handleRefresh} className='refresh refresh btn_plas'>Refresh</button>
          </div>
        </div>
      )}

            {showRefresh && (
        <div className="popup ">
          
          <div className="popup-content new_win"> 
            <div className="long">
            <button onClick={() => setShowRefresh(false)} className=' btn_plas close'> <img src={Arrow} alt="" />    </button> 
            <button onClick={() => setShowRefresh(false)} className=' btn_plas close'> <img src={Close} alt="" />    </button>
            </div>
            <div className="infor">
            <h3 >Raffle Results</h3>
              <div className="row cent">
                <p>You purchased</p>
                <p className='sec'>You purchased</p>

                
              </div>
              <div className="row cent">
                <p>You can claim</p>
                <p className='sec'>{displayValue} tokens</p>
              </div>
              </div>
              <button onClick={() =>setShowRefresh(false)} className=' btn_plas close claim'>Claim </button> 
              <button onClick={handleRefresh} className='refresh btn_plas '>Refresh</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
